import { useRouter } from 'next/router';
import React from 'react';
import DashboardPage from '../../components/Dashboard/DashboardPage';
import Stats from '../../components/Dashboard/Stats';
import withApollo from '../../lib/withApollo';

const StatsPage = () => {
  const router = useRouter();

  const { open } = router.query;

  return (
    <DashboardPage
      open={open}
      bottomNav={0}
      label="dashboard"
      content={<Stats />}
    />
  );
};

export default withApollo(StatsPage);
